<template>
  <div class="baseVerification">
    <div class="annual-verification-explain">
      <p>说明：</p>
      <p>1、本模块，针对已曾线下首次通过联盟“孵化基地”称号授予的用户，之后历年基地复审的提交权益。无论将来复审是否通过，都不影响本模块可用性。</p>
      <p>2、基地复审每年一次，具体时间见联盟通知，对用户开放基地复审提交与修改，在“基地复审提交与修改期“，不能重复创建提交。</p>
      <p>3、审批通过，则门户基地频道中，为园区做宣传展示，并在园区详情页中标记“孵化基地”称号。审批不通过或“复审提交与修改期”内不提交，则摘除“孵化基地”称号。</p>
    </div>

    <el-button v-if="examineType == 0" class="btn" type="primary" @click="insertRecord">复审提交</el-button>
    <el-button v-if="examineType !=0" class="btn" @click="NoFn" type="info">复审提交</el-button>

    <el-table :data="tableData" border style="width: 1600px;" class="table">
      <el-table-column fixed prop="index" label="序号" width="70"></el-table-column>

      <el-table-column prop="basementId" label="提审编号" width="200">
        <template slot-scope="scope">{{ 'TSBH'+scope.row.id || "-" }}</template>
      </el-table-column>

      <el-table-column prop="particularYear" label="提审年份" width="200">
        <template slot-scope="scope">{{ scope.row.particularYear || "-" }}</template>
      </el-table-column>

      <el-table-column prop="time" label="提审时间" width="350">
        <template slot-scope="scope">{{ scope.row.time || "-" }}</template>
      </el-table-column>

      <el-table-column prop="status" label="审核状态" width="200">
        <template slot-scope="scope">{{ scope.row.status || "-" }}</template>
      </el-table-column>

      <el-table-column prop="time2" label="审核时间" width="350">
        <template slot-scope="scope">{{ scope.row.time2 || "-" }}</template>
      </el-table-column>

      <el-table-column fixed="right" label="操作" width="200">
        <template slot-scope="scope">
          <el-button @click="checkRecord(scope.row)" type="text" size="small">查看</el-button>
          <el-popover
            v-if="scope.row.status === '审核失败'"
            placement="top"
            title
            width="200"
            trigger="hover"
            :content="scope.row.rejectReason"
          >
            <el-button type="text" slot="reference">原因</el-button>
          </el-popover>
          <el-button
            @click="retry(scope.row)"
            type="text"
            size="small"
            v-if="isUpdateEnable(scope.row.status, getLatest.particularYear,getLatest.endDate)"
          >修改</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="this.getTitle" :visible.sync="dialogFormVisible" center width="550px" :close-on-click-modal="false">
      <el-form :model="form" :disabled="checkFlag">
        <el-form-item label="提审年份：" :label-width="formLabelWidth">
          <span class="must-star">*</span>
          今年（{{thisYear}}年）
        </el-form-item>

        <el-form-item label="年审资料：" :label-width="formLabelWidth">
          <!--            <el-button type="primary" plain>上传</el-button>-->
          <span class="must-star">*</span>
            <form id="formData">
                <input
                  type="file"
                  id="inputName"
                  @change="getFile($event,1)"
                  multiple="multiplt"
                  accept=".docx, .doc, .pdf"
                  ref="examination"
                  :disabled="checkFlag"
                >
          </form>
          <div>
            <span class="tit">请下载右侧模板，填写完后上传</span>
            <span @click="getdownloadInfo()" class="tem">年审模板↓</span>
          </div>
          <div v-if="checkFlag||updateFlag">
            <a :href="form.histroryAnnualData">{{this.splitHistroryData(form.histroryAnnualData)}}</a>
          </div>
        </el-form-item>

        <el-form-item label="工作总结报告：" :label-width="formLabelWidth">
          <span class="must-star-report">*</span>
          <form id="formData1">
            <input
              type="file"
              @change="getFile($event,2)"
              multiple="multiplt"
              accept=".docx, .doc, .pdf, .zip"
              ref="summary"
              :disabled="checkFlag"
            >
          </form>
          <!--            <el-button type="primary" plain>上传</el-button>-->
          <div>
            <span class="tit">pdf或doc或zip，一个，不超过10M</span>
          </div>
          <div v-if="checkFlag||updateFlag">
            <a :href="form.histrorySummaryData">{{this.splitHistroryData(form.histrorySummaryData)}}</a>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="!checkFlag">
        <el-button type="primary" @click="submit()" :disabled="submitFlag">提 交</el-button>
        <el-button type="info" @click="cancelForm()">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'baseVerification',
  props: {},
  components: {},
  data () {
    return {
      tableData: [],
      dialogFormVisible: false,
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      formLabelWidth: '110px',
      thisYear: '',
      template: {},
      examination: '',
      thisFile: '',
      getLatest: {},
      examineType: 0,
      checkFlag: false,
      updateFlag: false,
      insertFlag: false,
      submitFlag: false,
      isUpload: false,
      templateYear: new Date().getFullYear(),
      id:'',
    }
  },
  computed: {
    getTitle () {
      if (this.checkFlag) {
        return '查看'
      } else if (this.updateFlag) {
        return '更新'
      } else {
        return '提交'
      }
    }
  },
  created () {},
  mounted () {
    this.backendAudit()
    this.addDate()
    this.backendTemplate()
    this.$parent.sureitem = '/baseVerification'
  },
  methods: {
    splitHistroryData (data) {
      if (data) {
        const arr = data.split('seperator_')
        return arr[arr.length - 1]
      } else {
        return ''
      }
    },
    NoFn () {
      this.examineType === 1 && this.$message('您已提交当前年份年审')
      this.examineType === 2 && this.$message('不在复审期间')
    },
    cancelForm () {
      // this.$refs.summary.value ='';
      // this.$refs.examination.value ='';
      document.getElementById('formData').reset()
      document.getElementById('formData1').reset()
      this.resetAll()
      this.dialogFormVisible = false
    },
    resetAll () {
      this.checkFlag = false
      this.updateFlag = false
      this.insertFlag = false
      this.submitFlag = false
    },
    retry (data) {
      console.log(data)
      this.resetAll()
      this.updateFlag = true
      this.dialogFormVisible = true
      this.id = data.id;
      this.form.histroryAnnualData = data.annualData
      this.form.histrorySummaryData = data.summaryData
    },
    async checkRecord (data) {
      console.log('checkRecord')
      console.log(data)
      console.log(data.annualData)
      console.log(data.summaryData)
      this.resetAll()
      this.templateYear = data.particularYear
      await this.backendTemplate()
      this.checkFlag = true
      this.dialogFormVisible = true
      console.log(data.annualData)
      console.log(data.summaryData)
      this.form.histroryAnnualData = data.annualData
      this.form.histrorySummaryData = data.summaryData
    },
    insertRecord () {
      this.resetAll()
      this.templateYear = new Date().getFullYear()
      this.backendTemplate()
      this.insertFlag = true
      this.dialogFormVisible = true
    },

    async backendAudit () {
      try {
        const res = await this.$get(this.$url.companyInfoManage.backendAudit)
        const { code, msg, data } = res.data
        if (code === 200) {
          for (var i = 0; i < data.length; i++) {
            if (Number(data[i].approvalResult) === 0) {
              data[i].status = '待审批'
            } else if (Number(data[i].approvalResult) === 1) {
              data[i].status = '审核通过'
            } else {
              data[i].status = '审核失败'
            }

            data[i].index = i + 1
            var date = data[i].gmtInsert.splice(0, 3)
            date = date.map(i => {
              return i.length < 4 ? ('0' + i).slice(-2) : i
            })
            var time = data[i].gmtInsert
            time = time.map(i => {
              return ('0' + i).slice(-2)
            })
            data[i].time = date.join('-') + ' ' + time.join(':')
            if (data[i].gmtModify == null) {
              data[i].time2 = ''
            } else {
              date = data[i].gmtModify.splice(0, 3)
              date = date.map(i => {
                return i.length < 4 ? ('0' + i).slice(-2) : i
              })
              time = data[i].gmtModify
              time = time.map(i => {
                return ('0' + i).slice(-2)
              })
              data[i].time2 = date.join('-') + ' ' + time.join(':')
            }
          }
          this.tableData = data
          this.isSubmitEnable()
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    },
    isInSubmitInteval (startTime, endTime) {
      const now = Date.now()
      const start = Date.parse(
        startTime.slice(0, 3).join('-') + ' ' + startTime.slice(3).join(':')
      )
      const end = Date.parse(
        endTime.slice(0, 3).join('-') + ' ' + endTime.slice(3).join(':')
      )
      if (now < start || now > end) {
        this.examineType = 2
      }
    },
    async isSubmitEnable () {
      try {
        const res = await this.$post(
          this.$url.companyInfoManage.getLatestAudit
        )
        const { code, msg, data } = res.data
        if (code === 200) {
          this.getLatest = data
          if (this.tableData.length > 0) {
            for (var a = 0; a < this.tableData.length; a++) {
              if (
                this.getLatest.particularYear ===
                this.tableData[a].particularYear
              ) {
                this.examineType = 1
              }
            }
          }
          this.isInSubmitInteval(
            this.getLatest.startDate,
            this.getLatest.endDate
          )
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    },
    handleClick (data) {
      console.log(data)
    },
    // 获取当前年月日
    addDate () {
      var nowDate = new Date()
      var thisDate = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate()
      }
      this.thisYear = thisDate.year
    },
    // 年审模板
    async backendTemplate () {
      try {
        const res = await this.$get(
          this.$url.companyInfoManage.backendTemplate + '/' + this.templateYear
        )
        const { code, msg, data } = res.data
        if (code === 200) {
          this.template = data
          this.template.annualAuditTemplate = data.annualAuditTemplate
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    },
    getdownloadInfo (row) {
      var url = this.template.annualAuditTemplate
      const fileName = url
      if ('download' in document.createElement('a')) {
        var downloadElement = document.createElement('a')
        downloadElement.href = url
        downloadElement.download = fileName
        document.body.appendChild(downloadElement)
        downloadElement.click()
        document.body.removeChild(downloadElement)
      }
    },
    // 复审提交
    async submit () {
      this.lock = true;
      this.lock1 = true;
      if (this.isUpload) {
        var inputDOM = this.$refs.summary
        var file = inputDOM.files
        var examination = this.$refs.examination
        var examinationFile = examination.files;
        // return false;
        // if (examinationFile.length === 0) {
        //   this.$message.error('请上传年审资料')
        //   return
        // }
        // if (file.length === 0) {
        //   this.$message.error('请上传年工作总结报告')
        //   return
        // }
        var formData = new FormData()
        formData.append('file', examinationFile[0])
        var formData2 = new FormData()
        formData2.append('file', file[0])
        if (this.submitFlag) {
          this.$message.info('正在提交，请稍等')
          return
        }
        this.submitFlag = true
        if(examinationFile.length > 0){
          try {
            const res = await this.$post(
              this.$url.companyInfoManage.upload,
              formData
            )
            const { code, msg, data } = res.data
            if (code === 200) {
              this.examination = data.fullUrl;
            } else {
              this.lock = false;
              this.$message.error(msg)
            }
          } catch (err) {
            console.log(err)
          }
        }

        if(file.length > 0){
           try {
             const res = await this.$post(
               this.$url.companyInfoManage.upload,
               formData2
             )
             const { code, msg, data } = res.data
             if (code === 200) {
               this.thisFile = data.fullUrl
             } else {
               this.lock1 = false;
               this.$message.error(msg)
             }
           } catch (err) {
             console.log(err)
           }

         }
        // console.log( this.examination,' this.examination')
        // console.log( this.examination == '',' this.examination')
        if(this.lock && this.lock1){
          try {
            const res = await this.$post(
              this.$url.companyInfoManage.audit,
              {
                annualData: this.examination==''?this.form.histroryAnnualData:this.examination,
                summaryData: this.thisFile==''?this.form.histrorySummaryData:this.thisFile,
                particularYear: this.getLatest.particularYear,
                auditId: this.getLatest.id,
                id:this.id
              }
            )
            const { code, msg, data } = res.data
            if (code === 200) {
              console.log(data)
              this.dialogFormVisible = false
              this.$message.success('提交成功')
              this.backendAudit()
            } else {
              this.$message.error(msg)
            }
          } catch (err) {
            console.log(err)
          }
        }
      

        // try {
        //   const res = await this.$post(
        //     this.$url.companyInfoManage.upload,
        //     formData
        //   )
        //   const { code, msg, data } = res.data
        //   if (code === 200) {
        //     this.examination = data.fullUrl
        //     try {
        //       const res = await this.$post(
        //         this.$url.companyInfoManage.upload,
        //         formData2
        //       )
        //       const { code, msg, data } = res.data
        //       if (code === 200) {
        //         this.thisFile = data.fullUrl
        //       } else {
        //         this.$message.error(msg)
        //       }
        //     } catch (err) {
        //       console.log(err)
        //     }
        //   } else {
        //     this.$message.error(msg)
        //   }
        // } catch (err) {
        //   console.log(err)
        // }
        this.resetAll()
      }
    },
    getFile (data, num) {
      if (num === 2) {
        if (data.target.files[0].size > 1024 * 1024 * 10) {
          this.$message('当前文件已经超过10M')
          this.isUpload = false
          return
        }
      }
      this.isUpload = true
    },
    isUpdateEnable (str, year, deadline) {
      const currentYear = new Date().getFullYear()
      if (currentYear > year) {
        return false
      }
      if (deadline) {
        const end = Date.parse(
          deadline.slice(0, 3).join('-') + ' ' + deadline.slice(3).join(':')
        )

        if (new Date() > end) {
          return false
        }
      }
      if (str !== '审核失败') {
        return false
      }
      return true
    }
  }
}
</script>

<style scoped lang="less">
.annual-verification-explain {
  width: 1600px;
  height: 150px;
  border: 1px solid #ccc;
  box-sizing: border-box;
  padding: 10px;
  margin: 0 0 30px 20px;
  font-size: 16px;
  color: #999;
  p {
    margin: 5px 0;
  }
}
.btn {
  margin-left: 20px;
}
.tit {
  font-size: 14px;
  color: #ccc;
  margin-left: 10px;
}
.tem {
  text-decoration: underline;
  color: blue;
  margin-left: 20px;
  cursor: pointer;
}
.must-star {
  position: absolute;
  left: -90px;
  top: 3px;
  color: red;
  font-size: 16px;
}
.must-star-report {
  position: absolute;
  left: -118px;
  top: 3px;
  color: red;
  font-size: 16px;
}
/deep/.el-table {
  margin: 20px 0 0 15px;
}
/deep/.el-dialog__header {
  box-sizing: border-box;
  padding: 46px 0 0;
}
/deep/.is-leaf {
  background-color: #3056d9;
  font-size: 14px;
  color: #fff !important;
  text-align: center !important;
}
/deep/.el-table__row:nth-of-type(2n-1) {
  background-color: #fafafa;
}
/deep/.cell {
  text-align: center !important;
}
/deep/.el-button--default {
  width: 119px;
  height: 34px;
}
</style>
